import { useState, useRef } from "react";
import SelectBox from "devextreme-react/select-box";
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { DateBox } from 'devextreme-react/date-box';
import { useGlobalState } from '../../contexts/global-state';
import { appConst } from '../../app-const';
import { useScreenSize } from '../../utils/media-query';

export default function EmploymentStatusSelectBox(props) {
  const { lookupData } = useGlobalState();
  const { isSmall, isXSmall } = useScreenSize();
  const [showChangeEmploymentStatusConfirmPopup, setShowChangeEmploymentStatusConfirmPopup] = useState(false);
  const [previousEmploymentStatusId, setPreviousEmploymentStatusId] = useState();
  const [employmentStatusId, setEmploymentStatusId] = useState(props.defaultValue);
  const [employmentStatusEffectiveDate, setEmploymentStatusEffectiveDate] = useState(new Date()); 
  const selectBoxRef = useRef(null);

  function renderShowPopup() {
    return (
      <Popup
        visible={showChangeEmploymentStatusConfirmPopup}
        width={(isSmall || isXSmall) ? "100%" : "20%"}
        height="25%"
        onHiding={() => {
          setShowChangeEmploymentStatusConfirmPopup(false);
        }}
        title="Select effective date..."
        showCloseButton={false}
      >
        <div>
        </div>
        <DateBox
          defaultValue={new Date()}
          max={new Date()}
          type="date"
          displayFormat="yyyy-MM-dd"
          dateSerializationFormat="yyyy-MM-dd"
          onValueChanged={(e) => {
            setEmploymentStatusEffectiveDate(e.value);
          }}
        />
        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px'
        }} >
          <Button
            text='Ok'
            width={150}
            onClick={
              () => {
                setShowChangeEmploymentStatusConfirmPopup(false);
                props.setEmploymentValues(employmentStatusId, employmentStatusEffectiveDate);
              }
            }
          />
          <Button
            text='Cancel'
            width={150}
            onClick={
              () => {
                setShowChangeEmploymentStatusConfirmPopup(false);
                selectBoxRef.current.instance().option("value", previousEmploymentStatusId);
              }
            }
          />
        </div>
      </Popup>)
  }

  return (
    <>
    { showChangeEmploymentStatusConfirmPopup && renderShowPopup()}
      <SelectBox
        id="employmentSelectbox"
        ref={selectBoxRef}
        searchEnabled={false}
        {...appConst.defaultSelectBoxOptions}
        dataSource={lookupData.employmentStatuses}
        showClearButton={false}
        defaultValue={props.defaultValue}
        onValueChanged={(e) => {
          if (typeof e.event === 'undefined') return;

          const selectedItem = e.component.option("selectedItem");
          setEmploymentStatusId(e.value);
          setPreviousEmploymentStatusId(e.previousValue);

          if (selectedItem && selectedItem.confirm) {
            setShowChangeEmploymentStatusConfirmPopup(true);
          } else {
            props.setEmploymentValues(e.value, null);
          }
        }}
      />
    </>
  );
}